import useAutoRemoveAuth from 'hooks/useAutoRemoveAuth';
import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'stores';
import { setUser } from 'stores/auth';
import { MeQuery } from 'queries';

function Private() {
  const { login, user } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  useAutoRemoveAuth();

  // 로그인 상태면 항상 /me 를 갱신해 permission 변경을 즉시 반영.
  const { data: me } = MeQuery.useGet(login);

  useEffect(() => {
    if (me) {
      dispatch(setUser(me));
    }
  }, [me, dispatch]);

  if (login) {
    return <Outlet />;
  }

  return <Navigate to={'/login'} />;
}

export default Private;
